// extracted by mini-css-extract-plugin
export default {"added":"AddUserToChannel_added__rmLza","add":"AddUserToChannel_add__JzvgV","searchBox":"AddUserToChannel_searchBox__4DWzG","container":"AddUserToChannel_container__5H7Cx"};